<template>
  <div>
    <Head title="កម្ចី" />
    <h1 class="moul flex items-center mb-8 text-2xl"><CurrencyDollarIcon class="mr-2 w-8 h-8" /> កម្ចី</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block mt-4 text-gray-700">ស្ថានភាព:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null">បង្ហាញតែកម្ចីមិនបានលុប</option>
          <option value="with">ជាមួយកម្ចីដែលបានលុប</option>
          <option value="only">បង្ហាញតែកម្ចីដែលបានលុប</option>
        </select>
      </search-filter>

      <Link class="btn-indigo flex items-center" href="/loans/create">
        <PlusIcon class="mr-1 w-4 h-4" />
        <span>បង្កើត</span>
        <span class="hidden md:inline">ថ្មី</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-4">ID កម្ចី</th>
          <th class="pb-4 pt-6 px-2">ទឹកប្រាក់</th>
          <th class="pb-4 pt-6 px-4">កាលបរិច្ឆេទ</th>
          <th class="pb-4 pt-6 px-4">អត្រាការប្រាក់</th>
          <th class="pb-4 pt-6 px-4">ប្រភេទកម្ចី</th>
          <th class="pb-4 pt-6 px-4">រយៈពេល</th>
          <th class="pb-4 pt-6 px-4">ឈ្មោះអ្នកខ្ចី</th>
          <th class="pb-4 pt-6 px-4">សេវាកម្មរដ្ឋបាល</th>
          <th class="pb-4 pt-6 px-4">មន្ត្រីឥណទាន</th>
          <th class="pb-4 pt-6 px-4">ស្ថានភាព</th>
        </tr>
        <tr v-for="loan in loans.data" :key="loan.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-4 py-4" :href="`/loans/${loan.id}/schedule`" tabindex="-1">
              {{ loan.loan_id }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-2 py-4 focus:text-indigo-500" :href="`/loans/${loan.id}/schedule`">
              {{ loan.amount }}
              <icon v-if="loan.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-4 py-4" :href="`/loans/${loan.id}/schedule`" tabindex="-1">
              {{ formattedDate(loan.loan_date) }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-4 py-4 focus:text-indigo-500" :href="`/loans/${loan.id}/schedule`"> {{ loan.loan_type=="បង់ថយ"?"1.3":"1.5" }}%</Link>
          </td>
          <td class="border-t">
            <Link class="flex text-green-500 items-center px-4 py-4 focus:text-indigo-500" :href="`/loans/${loan.id}/schedule`"> {{ loan.loan_type }} </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-4 py-4 focus:text-indigo-500" :href="`/loans/${loan.id}/schedule`"> {{ loan.term }} {{ loan.term_period == 'week' ? 'សប្តាហ៍' : 'ខែ' }}</Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-4 py-4" :href="`/loans/${loan.id}/schedule`" tabindex="-1">
              <div>
                {{ loan.borrower }}
              </div>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-4 py-4 focus:text-indigo-500" :href="`/loans/${loan.id}/schedule`"> {{ loan.service_fee }}% </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-4 py-4" :href="`/loans/${loan.id}/schedule`" tabindex="-1">
              {{ loan.officer }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center justify-center px-4 py-4" :href="`/loans/${loan.id}/schedule`" tabindex="-1">
              <span class="text-yellow-400 font-medium" v-if="loan.status == 0">{{ 'មិនទាន់បង់' }}</span>
              <span class="text-indigo-400 font-medium" v-else-if="loan.status == 1">{{ 'កំពុងបង់' }}</span>
              <span class="text-red-400 font-medium" v-else>{{ 'បានបង់ហើយ' }}</span>
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/loans/${loan.id}/schedule`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="loans.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="8">ពុំមានកម្ចីត្រូវបានបង្ហាញទេ!</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="loans.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import { CurrencyDollarIcon, PlusIcon } from '@heroicons/vue/24/outline'
import { formattedDate } from '@/helper'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    CurrencyDollarIcon,
    PlusIcon,
  },
  layout: Layout,
  props: {
    filters: Object,
    loans: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        gender: this.filters.gender,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/loans', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    formattedDate,
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
